/**
 * ============================================================================
 * Premium Testimonials
 * Shopify Dawn 15.2
 * Version 2.0
 * ============================================================================
 */

class Testimonials {

  constructor(section) {

    this.section = section;

    this.track = section.querySelector('.testimonials__track');

    this.cards = [...section.querySelectorAll('.testimonials__card')];

    this.buttons = [...section.querySelectorAll('.testimonials__button')];

    this.videos = [...section.querySelectorAll('video')];

    this.isSlider =
      section.classList.contains('testimonials--slider');

    this.resizeTimer = null;

    this.observer = null;

    this.videoObserver = null;

    this.currentIndex = 0;

    this.maxIndex = this.cards.length - 1;
    this.direction = 1;

    this.init();

  }

  /**
   * --------------------------------------------------------------------------
   * Init
   * --------------------------------------------------------------------------
   */

 init() {

  // this.initVisibility();

  this.initEqualHeight();

  this.initVideos();

  if (this.isSlider) {

    this.initSlider();

    this.initAutoplay();

  }

  this.bindResize();

}

  /**
   * --------------------------------------------------------------------------
   * Fade In Observer
   * --------------------------------------------------------------------------
   */

  initVisibility() {

    this.observer = new IntersectionObserver(

      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {

            entry.target.classList.add('is-visible');

            this.observer.unobserve(entry.target);

          }

        });

      },

      {
        threshold: 0.15
      }

    );

    this.cards.forEach((card) => {

      this.observer.observe(card);

    });

  }

  /**
   * --------------------------------------------------------------------------
   * Equal Height
   * --------------------------------------------------------------------------
   */

  initEqualHeight() {

    if (window.innerWidth < 750) return;

    let tallest = 0;

    this.cards.forEach((card) => {

      card.style.height = 'auto';

      tallest = Math.max(
        tallest,
        card.offsetHeight
      );

    });

    this.cards.forEach((card) => {

      card.style.height = `${tallest}px`;

    });

  }

  /**
   * --------------------------------------------------------------------------
   * Videos
   * --------------------------------------------------------------------------
   */

  initVideos() {

    if (!this.videos.length) return;

    this.videoObserver = new IntersectionObserver(

      (entries) => {

        entries.forEach((entry) => {

          const video = entry.target;

          if (!entry.isIntersecting) {

            video.pause();

          }

        });

      },

      {
        threshold: 0.4
      }

    );

    this.videos.forEach((video) => {

      this.videoObserver.observe(video);

    });

  }

  /**
   * --------------------------------------------------------------------------
   * Resize
   * --------------------------------------------------------------------------
   */

  bindResize() {

    window.addEventListener(

      'resize',

      () => {

        clearTimeout(this.resizeTimer);

        this.resizeTimer = setTimeout(() => {

          this.initEqualHeight();

        }, 150);

      }

    );

  }

  /**
   * --------------------------------------------------------------------------
   * Slider
   * --------------------------------------------------------------------------
   */

initSlider() {

    this.initNavigation();

    this.initTouch();

    this.initKeyboard();

}
  /**
   * --------------------------------------------------------------------------
   * Navigation
   * --------------------------------------------------------------------------
   */

  initNavigation() {

    if (!this.buttons.length) return;

    this.buttons.forEach((button) => {

      button.addEventListener("click", () => {

        const direction = button.dataset.direction;

        this.slide(direction);

      });

    });

  }

  /**
 * --------------------------------------------------------------------------
 * Slide
 * --------------------------------------------------------------------------
 */

slide(direction = "next") {

  if (!this.cards.length) return;

  const gap =
    parseFloat(getComputedStyle(this.track).gap) || 0;

  const width =
    this.cards[0].offsetWidth + gap;

  if (direction === "next") {

    this.currentIndex++;

  } else {

    this.currentIndex--;

  }

  if (this.currentIndex > this.maxIndex) {

  this.currentIndex = this.maxIndex;

}

if (this.currentIndex < 0) {

  this.currentIndex = 0;

}

  this.track.scrollTo({

    left: this.currentIndex * width,

    behavior: "smooth"

  });

}

  /**
   * --------------------------------------------------------------------------
   * Desktop Drag
   * --------------------------------------------------------------------------
   */

initTouch() {

  let pressed = false;

  let startX = 0;

  let scrollLeft = 0;

  this.track.addEventListener("mousedown", (event) => {

    pressed = true;

    startX = event.pageX;

    scrollLeft = this.track.scrollLeft;

    this.track.classList.add("is-dragging");

  });

  window.addEventListener("mouseup", () => {

    pressed = false;

    this.track.classList.remove("is-dragging");

  });

  window.addEventListener("mousemove", (event) => {

    if (!pressed) return;

    event.preventDefault();

    const walk = (event.pageX - startX) * 1.25;

    this.track.scrollLeft = scrollLeft - walk;

  });


    /* ---------- Mobile ---------- */

    let touchStart = 0;

    this.track.addEventListener(

      "touchstart",

      (event) => {

        touchStart = event.touches[0].clientX;

      },

      { passive: true }

    );

    this.track.addEventListener(

      "touchend",

      (event) => {

        const end = event.changedTouches[0].clientX;

        const diff = touchStart - end;

        if (Math.abs(diff) < 40) return;

        this.slide(

          diff > 0

            ? "next"

            : "prev"

        );

      },

      { passive: true }

    );

  }

  /**
   * --------------------------------------------------------------------------
   * Mouse Wheel
   * --------------------------------------------------------------------------
   */

  /* initWheel() {

  this.track.addEventListener(

    "wheel",

    (event) => {

      if (

        Math.abs(event.deltaY)

        >

        Math.abs(event.deltaX)

      ) {

        event.preventDefault();

        this.track.scrollLeft += event.deltaY;

      }

    },

    {

      passive: false

    }

  );

} */

  /**
   * --------------------------------------------------------------------------
   * Keyboard
   * --------------------------------------------------------------------------
   */

  initKeyboard() {

    this.section.addEventListener(

      "keydown",

      (event) => {

        if (event.key === "ArrowRight") {

          this.slide("next");

        }

        if (event.key === "ArrowLeft") {

          this.slide("prev");

        }

      }

    );

  }

  /**
   * --------------------------------------------------------------------------
   * Pause Videos
   * --------------------------------------------------------------------------
   */

  pauseVideos() {

    this.videos.forEach((video) => {

      video.pause();

    });

  }
  /**
   * --------------------------------------------------------------------------
   * Autoplay
   * --------------------------------------------------------------------------
   */

  initAutoplay() {

  const enabled =
    this.section.dataset.autoplay === "true";

  if (!enabled) return;

  const speed =
    parseInt(this.section.dataset.speed, 10) || 5000;

  if (this.autoplay) {

    clearInterval(this.autoplay);

  }

  this.autoplay = setInterval(() => {

    if (this.currentIndex >= this.maxIndex) {

      this.direction = -1;

    }

    if (this.currentIndex <= 0) {

      this.direction = 1;

    }

    this.slide(

      this.direction > 0
        ? "next"
        : "prev"

    );

  }, speed);

  this.section.addEventListener("mouseenter", () => {

    clearInterval(this.autoplay);

    this.autoplay = null;

  });

  this.section.addEventListener("mouseleave", () => {

    if (!this.autoplay) {

      this.initAutoplay();

    }

  });

}

  /**
   * --------------------------------------------------------------------------
   * Destroy
   * --------------------------------------------------------------------------
   */

 destroy() {

  if (this.observer) {

    this.observer.disconnect();

  }

  if (this.videoObserver) {

    this.videoObserver.disconnect();

  }

  if (this.autoplay) {

    clearInterval(this.autoplay);

    this.autoplay = null;

  }

}
}


/* ============================================================================
   Shopify Theme Editor
============================================================================ */

const testimonialInstances = new Map();

function initTestimonials(scope = document) {

  scope
    .querySelectorAll(".testimonials")
    .forEach((section) => {

      if (testimonialInstances.has(section)) return;

      testimonialInstances.set(
        section,
        new Testimonials(section)
      );

    });

}

document.addEventListener("DOMContentLoaded", () => {

  initTestimonials();

});

/* ============================================================================
   Shopify Theme Events
============================================================================ */

document.addEventListener("shopify:section:load", (event) => {

  initTestimonials(event.target);

});

document.addEventListener("shopify:section:unload", (event) => {

  const section = event.target.querySelector(".testimonials");

  if (!section) return;

  const instance = testimonialInstances.get(section);

  if (!instance) return;

  instance.destroy();

  testimonialInstances.delete(section);

});

document.addEventListener("shopify:section:select", (event) => {

  const section = event.target.querySelector(".testimonials");

  if (!section) return;

  section.scrollIntoView({

    behavior: "smooth",

    block: "center"

  });

});

document.addEventListener("shopify:block:select", (event) => {

  const block = event.target;

  if (!block.classList.contains("testimonials__card")) return;

  block.scrollIntoView({

    behavior: "smooth",

    inline: "center",

    block: "nearest"

  });

});

/* ============================================================================
   Resize Observer
============================================================================ */

if ("ResizeObserver" in window) {

  const resizeObserver = new ResizeObserver(() => {

    testimonialInstances.forEach((instance) => {

      instance.initEqualHeight();

    });

  });

  document
    .querySelectorAll(".testimonials")
    .forEach((section) => {

      resizeObserver.observe(section);

    });

}

/* ============================================================================
   Aurora 2.0
============================================================================ */

document.addEventListener("pointermove", (event) => {

  document
    .querySelectorAll(".testimonials__card")
    .forEach((card) => {

      const rect = card.getBoundingClientRect();

      const x =
        ((event.clientX - rect.left) / rect.width) * 100;

      const y =
        ((event.clientY - rect.top) / rect.height) * 100;

      card.style.setProperty(
        "--fog-x",
        `${Math.max(0, Math.min(100, x))}%`
      );

      card.style.setProperty(
        "--fog-y",
        `${Math.max(0, Math.min(100, y))}%`
      );

    });

});